import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { lazy, Suspense } from "react";
import { Loader } from "@mantine/core";
const LottieLoader = lazy(() => import("./LottieLoader"));
const AnimatedLoader = (props) => (_jsx(Suspense, { fallback: _jsx(Loader, { ...props }), children: _jsx(LottieLoader, { ...props }) }));
export default AnimatedLoader;
